export default class SectionsTransitions {
    constructor({ $sections = [] }) {
        this.$sections = $sections;

        if (this.$sections.length) {
            this.init();
        }
    }

    init() {
        const mediaTablet = window.matchMedia('(max-width: 768px)').matches;
        const mediaLaptop = window.matchMedia('(max-width: 1024px)').matches;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('-animated');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: mediaTablet ? 0.15 : mediaLaptop ? 0.4 : 0.65
        });

        this.$sections.forEach(($section) => {
            observer.observe($section);
        });
    }
}